import React,{useContext, useEffect, useState} from 'react'
import { cartContext } from '../Cartcontext'

const Cart = () => {
    let total = 0;
    const [products, setProducts] = useState([]);
    const [priceFetched, setPriceFetched] = useState(false);//this state is use for only calling the usestate only once.
    const {cart, setCart}  = useContext(cartContext);
    // console.log(cart);

    useEffect(() => {
        if(!cart.items){
            return;
        }
        if(priceFetched){
            return;
        }
        fetch('https://ecom-rest-apis.herokuapp.com/api/products/cart-items',{
            method : 'POST',
            headers : { 
                'content-Type' : 'application/json'
            },
            body : JSON.stringify({ids : Object.keys(cart.items)})  //Object.keys give the value/id of the product in the array
        } ).then(res => res.json())
        .then(products =>{
            setProducts(products); 
            setPriceFetched(true);
        })

    }, [cart, priceFetched])

    const getQty = (productId) =>{
            return cart.items[productId];
    }

    const increament = (productId) =>{
        const existingQty = cart.items[productId];
        const _cart = {...cart};
        _cart.items[productId] = existingQty + 1;
        _cart.totalItems += 1;
        setCart(_cart);
    }

    const decreament = (productId) =>{
        const existingQty = cart.items[productId];
        if(existingQty === 1){
            return ;
        }
        const _cart = {...cart};
        _cart.items[productId] = existingQty - 1;
        _cart.totalItems -= 1;
        setCart(_cart);
    }

    const getsum = (productId, price) =>{
        const sum = price * getQty(productId);
        total += sum;
        return sum;
    }

    const handleDelete = (productId) =>{
        const _cart = {...cart};
        const qty = _cart.items[productId];
        delete _cart.items[productId];
        _cart.totalItems -= qty;
        setCart(_cart);
        const updateProduct = products.filter((product) =>{
            return product._id !== productId
        })
        setProducts(updateProduct);
    }

    const handleOrderNow = () =>{
        window.alert('order place successfully!');
        setProducts([]);
        setCart([]);
    }
    return (
        
        products.length ?
        <div className="container mx-auto lg: 1/2 w-full pd-24">
            <h1 className = "my-12 font-bold">Cart itmes</h1>
            <ul>
                {
                    products.map((product) =>{
                        return (
                            <>  
                                <li className="mb-12" key = {product._id}>
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center">
                                            <img className="h-16" src={product.image} alt="pizza_image" />
                                            <span className="font-bold ml-4 w-48">{product.name}</span>
                                        </div>
                                        <div>
                                            <button onClick ={() =>{decreament(product._id)}} className="bg-yellow-500 px-5 py-2 rounded-full leading-none"> - </button>
                                            <b className="px-4">{getQty(product._id)}</b>
                                            <button onClick ={() =>{increament(product._id)}} className="bg-yellow-500 px-5 py-2 rounded-full leading-none"> + </button>
                                        </div>
                                        <span>₹ {getsum(product._id, product.price)}</span>
                                        <button onClick={() =>{ handleDelete(product._id)}}className="bg-red-500 px-5 py-2 rounded-full leading-none text-white">Delete</button>
                                    </div>
                                </li>
                            </>
                        )
                    })
                }
                <hr className="my-6"/>
                <div className="text-right">
                    <b>Grand Total</b> : ₹ {total}
                </div>
                <div className="text-right mt-6">
                    <button onClick = {handleOrderNow}className="bg-yellow-500 px-5 py-2 rounded-full leading-none">Order Now</button>
                </div>
            </ul>
        </div>
        : <img className = "mx-auto w-1/2 mt-12" src="/images/empty-cart.png" alt="empty_cart" />
    )
}

export default Cart
